import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const UserInfo = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #484848;
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  overflow: hidden;
`;

const StyledUserTag = styled.div`
  border-radius: 2px;
  background-color: #FFB7B5;
  color: #FFF;
  font-size: 12px;
  padding: 0 5px;
  margin-left: 9px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  @media (max-width: 960px) {
    margin-left: 3px;
  }
`;

const UserDescription = styled.div`
  color: #484848;
  font-size: 12px;
  margin-top: 8px;
  @media (max-width: 960px) {
    margin-top: 3px;
  }
`;

const UserTag = ({ children }) => (
  <StyledUserTag className="user-chat-tag">
    {children}
  </StyledUserTag>
);

UserTag.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  UserTag,
  UserInfo,
  UserDescription,
};
